module.exports = __webpack_public_path__ + "img/3.fb0e96ac.png";